module.exports = __webpack_public_path__ + "workspace/static/img/register.40cd722.png";